export const formatWeight = (raw: number): string => {
  const weightFormatOptions = {
    style: 'unit',
    unit: raw > 1000 ? 'kilogram' : 'gram'
  };

  return new Intl.NumberFormat(
    'ru-RU',
    weightFormatOptions
  ).format(raw > 1000 ? raw / 1000 : raw);
};
